export default {"src":"/_next/static/media/apache_logo.19400358.svg","height":55,"width":42,"blurWidth":0,"blurHeight":0};